import HtmlParser from 'html-react-parser'
import { Fragment } from 'react'
import { RichFormattedMessageProps } from './rich-formatted-message.props'

export const RichFormattedMessage = (props: RichFormattedMessageProps) => {
  return <Fragment>{HtmlParser(props.message ?? '')}</Fragment>
}
